export enum ScopeAnalysisStatus {
    NOT_ANALYZED = 0,
    ANALYZED
}
